import React from "react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import PDCReportDocument from "./PDCReportDocument";
import Modal from "../common/CommonModal";

const PDCReportPrint = ({ pdcReportPrintDataFromAPI, setIsPDCReportPrint , isPDCReportPrint }) => {
  const onClose = () => {
    setIsPDCReportPrint(false);
  };

  console.log("pdcReportPrintDataFromAPI:", pdcReportPrintDataFromAPI);
  return (
    <Modal
      isOpen={isPDCReportPrint}
      onClose={() => setIsPDCReportPrint(false)}
      title={"PDC Report"}
      size="xxl"
      header={true}
    >
      <div className="flex flex-col items-center h-screen">
        <div className="w-full h-[82vh] border border-gray-300 mb-4">
          <PDFViewer width="100%" height="100%">
            <PDCReportDocument pdcReportPrintData={pdcReportPrintDataFromAPI} />
          </PDFViewer>
        </div>
      </div>
    </Modal>
  );
};

export default PDCReportPrint;
